
import type { RewardPool } from '@shared/api/types/rewardPools';

import { type DialogProps } from '@radix-ui/react-dialog';
import { RewardOptions } from '@store:web/components/entities/rewardPool';
import { CustomDialog } from '@ui/uikit/components/common/Dialog';

interface Props extends DialogProps {
  rewardPool: RewardPool;
}

export const RequirementsDialog = ({ rewardPool, ...props }: Props) => {
  return (
    <CustomDialog size="lg" title="Pool Requirements" titleIsLeftAligned noBottomPadding {...props}>
      <RewardOptions
        rewardPool={rewardPool}
        showHeader={false}
        showFooter={false}
        hasBorders={false}
      />
    </CustomDialog>
  );
};
